import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40848 31310"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970247312992">
        <path
          d="M19335 31310c450 0 895-198 1196-577 524-661 414-1620-247-2144L3981 15655 20284 2721c660-524 771-1482 247-2143s-1483-771-2143-248L577 14460c-364 289-577 729-577 1195s213 906 577 1195l17811 14130c280 223 614 330 947 330z"
          className="fil0"
        />
        <path
          d="M29328 31310c450 0 895-198 1196-577 524-661 414-1620-247-2144L13974 15655 30277 2721c660-524 771-1482 247-2143s-1484-771-2144-248L10570 14460c-365 289-577 729-577 1195s212 906 577 1195l17810 14130c281 223 616 330 948 330z"
          className="fil0"
        />
        <path
          d="M39321 31310c451 0 895-198 1197-577 523-661 413-1620-248-2144L23967 15655 40270 2721c660-524 771-1482 248-2143-525-661-1483-771-2144-248L20564 14460c-365 289-578 729-578 1195s213 906 578 1195l17810 14130c280 223 614 330 947 330z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
